import { render, staticRenderFns } from "./genre-grid-tile.vue?vue&type=template&id=571b98ce&scoped=true"
import script from "./genre-grid-tile.vue?vue&type=script&setup=true&lang=js"
export * from "./genre-grid-tile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre-grid-tile.vue?vue&type=style&index=0&id=571b98ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b98ce",
  null
  
)

export default component.exports